import React from 'react';

export default class VideoOne extends React.Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + "/";

        return (
            <>
                {/* Start Video One */}
                <section className="video-one" style={{ position: "relative"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="video-one__inner" style={{ position: "relative" }}>

                                    {/* Video Background */}
                                    <div
                                        className="video-one__bg"
                                        style={{
                                            overflow: "hidden",
                                            height: "500px",
                                            borderRadius: "10px",
                                            position: "relative",
                                        }}
                                    >
                                        <video
                                            src={`${publicUrl}assets/video/homevideo.mp4`}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                pointerEvents: "none", // disables click
                                                display: "block",
                                            }}
                                        />

                                        {/* Black Overlay */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0,0,0,0.5)", // 50% opacity black
                                            }}
                                        ></div>
                                    </div>

                                    {/* Content on top of video */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "#fff",
                                            zIndex: 2,
                                        }}
                                    >
                                        <h1></h1>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Video One */}
            </>
        );
    }
}
